// Lib
import React from 'react';

// Utils
import rafThrottle from '../../../common/utils/lib/rafThrottle';

export default (DecoratedComponent) => {
    class renderThrottleDecorator extends React.Component {
        constructor(props) {
            super(props);
            this.state = {};
        }

        componentWillMount() {
            this.setState({ props: this.props });
        }

        componentWillReceiveProps(nextProps) {
            this.throttledSetState({ props: nextProps });
        }

        shouldComponentUpdate(nextProps, nextState) {
            return this.state !== nextState;
        }

        componentWillUnmount() {
            this.throttledSetState.cancel();
        }

        throttledSetState = rafThrottle(this.setState.bind(this));

        render() {
            return <DecoratedComponent {...this.state.props} />;
        }
    }

    renderThrottleDecorator.propTypes = {};

    return renderThrottleDecorator;
};
